import * as actionTypes from "./actionTypes";

// Cancel Order
export const mallCancelOrder = (id, data) => {
  return {
    type: actionTypes.MALL_CANCEL_ORDER,
    id,
    data
  };
};

export const mallCancelOrderSuccess = () => {
  return {
    type: actionTypes.MALL_CANCEL_ORDER_SUCCESS
  };
};

export const mallCancelOrderFail = () => {
  return {
    type: actionTypes.MALL_CANCEL_ORDER_FAIL
  };
};
// END Cancel Order

// Withdraw Cancellation
export const mallWithdrawCancellation = (id, orderID) => {
  return {
    type: actionTypes.MALL_WITHDRAW_CANCELLATION,
    id,
    orderID
  };
};

export const mallWithdrawCancellationSuccess = () => {
  return {
    type: actionTypes.MALL_WITHDRAW_CANCELLATION_SUCCESS
  };
};

export const mallWithdrawCancellationFail = () => {
  return {
    type: actionTypes.MALL_WITHDRAW_CANCELLATION_FAIL
  };
};
// END Withdraw Cancellation
